/**
 * @generated SignedSource<<92639e9d2ab8910e76f6be30b570f909>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceMoreCard_productizedService$data = {
  readonly price: {
    readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceCardPrice_price">;
  };
  readonly slug: string;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceCardDetails_productizedService">;
  readonly " $fragmentType": "ProductizedServiceMoreCard_productizedService";
};
export type ProductizedServiceMoreCard_productizedService$key = {
  readonly " $data"?: ProductizedServiceMoreCard_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceMoreCard_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceMoreCard_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductizedServicePrice",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductizedServiceCardPrice_price"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceCardDetails_productizedService"
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "44fcd2de77126e08713d140925f947ba";

export default node;
